import React from 'react';
import CountUp from 'react-countup';
import { useNavigate } from 'react-router-dom';

export default function HomeHero({ legalCount, auditCount }) {
  const navigate = useNavigate();
  return (
    <section className="hero" aria-labelledby="hero-title">
      <span className="flash-line" aria-hidden="true"></span>
      <div className="hero-copy">
        <p className="eyebrow">DALMAF your reliable partner</p>
        <h1 id="hero-title" className="dh-title-1">
          Integrated Audit, Legal, HR Compliance &amp; Investment Solutions
        </h1>
        <p className="dh-text">
          We deliver sustainable outcomes and solutions for your business needs through
          tech-enabled, purposeful services across audit &amp; assurance, advisory, consulting,
          regulatory compliance, legal support, and HR governance.
        </p>
        <div className="hero-proof" aria-label="DALMAF strengths">
          <span className="hero-proof-span">
            <strong className="hero-proof-strong">30+</strong> years experience
          </span>
          <span className="hero-proof-span">
            <strong className="hero-proof-strong">
              <CountUp start={0} end={legalCount} delay={0.3} duration={3} />
            </strong> legal service lines
          </span>
          <span className="hero-proof-span">
            <strong className="hero-proof-strong">
              <CountUp start={0} end={auditCount} delay={0.3} duration={3} />
            </strong> audit service lines
          </span>
        </div>
        <div className="hero-actions">
          <a className="btn btn-primary" onClick={(e) => {
            e.preventDefault();
            navigate("/service-listing");
          }}>Explore Services</a>
          <a className="btn btn-light" href="#products">View Products</a>
          <a className="dalmaf-btn-outline" href="#contact">Contact DALMAF</a>
        </div>
      </div>

      <div className="hero-visual" aria-label="DALMAF consultant">
        <div className="orbital-card client-card">
          <strong className="orbital-card-strong">
            <CountUp start={0} end={legalCount} delay={0.3} duration={3} />
          </strong>
          <span className="orbital-card-span">Legal Services</span>
        </div>
        <img src="/img/hero/audit1.png" alt="DALMAF audit and compliance consultant" />
        <div className="orbital-card audit-card">
          <strong className="orbital-card-strong">
            <CountUp start={0} end={auditCount} delay={0.3} duration={3} />
          </strong>
          <span className="orbital-card-span">Audit Services</span>
        </div>
        <div className="assurance-panel">
          <span className="assurance-label">Operational clarity</span>
          <strong className="assurance-value">Audit + Legal + HR in one advisory desk</strong>
        </div>
      </div>
    </section>
  );
}
